import { getSignal } from '@api/index';
import { Image, Text, View } from '@react-pdf/renderer';
import { formatTwoOrThreeDecimals } from '@utils/formatters';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import { HydratedEntity } from '../../../types';
import recommendationIcon from '../assets/recommendation.png';

export const RecuperationRecommendation = ({ data }: { data: HydratedEntity }) => {
    const rating = getSignal(data, 'electricRecuperationRating', 0.0);
    const improvement = getSignal(data, 'electricRecuperationNextLevel', 0.0);
    const level = Math.floor(rating / 20);
    return (
        <View
            style={{
                border: '1px solid #30b4c0',
                borderRadius: '6px',
                backgroundColor: '#ebf9fa',
                padding: '5px 10px',
            }}
        >
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Image src={recommendationIcon} style={{ width: 14.25, marginRight: 5 }} />
                <Text style={{ fontFamily: 'Bold' }}>
                    <FormattedMessage id="electricRecuperationRatingRecommendationTitle" />
                </Text>
            </View>
            <Text>
                <FormattedMessage
                    id={`electricRecuperationRatingRecommendation${level}`}
                    values={{ improvement: formatTwoOrThreeDecimals(improvement) }}
                />
            </Text>
        </View>
    );
};
